import angular from 'angular';
import '../../common/localizationMapService';

'use strict';

const gamesServices = angular.module('applicationModule.gamesServices', []);


gamesServices.factory('Game', ['GameAPI', function (GameAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return GameAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (gameId, appId) {
            return GameAPI.getGame(gameId, appId);
        },
        save: function (game, editMode) {
            if (editMode) {
                return GameAPI.editGame(game);
            } else {
                return GameAPI.createGame(game);
            }
        },
        remove: function (gameId) {
            return GameAPI.removeGame(gameId);
        }
    };
}]);

gamesServices.service('GameAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/game/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.getGame = function (gameId, appId) {
        return $http.get(API_URL + gameId, {params: {app_id: appId}});
    };

    this.createGame = function (game) {
        return $http.post(API_URL, game);
    };

    this.editGame = function (game) {
        return $http.put(API_URL + game.id, game);
    };

    this.removeGame = function (gameId) {
        return $http.delete(API_URL + gameId);
    };

}]);

gamesServices.factory('GamePoint', ['GamePointAPI', function (GamePointAPI) {
    'use strict';

    return {
        getList: function (gameId, appId, params) {
            return GamePointAPI.getList(gameId, appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        getPoint: function (pointId, appId) {
            return GamePointAPI.getPoint(pointId, appId);
        },
        save: function (point, editMode) {
            if (editMode) {
                return GamePointAPI.editPoint(point);
            } else {
                return GamePointAPI.createPoint(point);
            }
        },
        remove: function (point) {
            return GamePointAPI.removePoint(point);
        },
        getTypes: function () {
            return GamePointAPI.getTypes();
        },
        getCluePoints: function (gameId, pointId) {
            return GamePointAPI.getCluePoints(gameId, pointId);
        }
    };
}]);

gamesServices.service('GamePointAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/game-points/';

    this.getList = function (gameId, appId, params) {
        return $http.get(API_URL, {
            params: angular.extend(AppsoupAPI.getTableParams(params), {
                app_id: appId,
                game_id: gameId
            })
        });
    };

    this.getPoint = function (pointId, appId) {
        return $http.get(API_URL + pointId, {params: {app_id: appId}});
    };

    this.createPoint = function (point) {
        return $http.post(API_URL, point);
    };

    this.editPoint = function (point) {
        return $http.put(API_URL + point.id, point);
    };

    this.removePoint = function (point) {
        return $http.delete(API_URL + point.id, {params: {app_id: point.app_id}});
    };

    this.getTypes = function () {
        return $http.get(API_URL + 'types/point');
    };

    this.getCluePoints = function (gameId, pointId) {
        if (pointId) {
            return $http.get(API_URL + 'clues/points/' + gameId + '/' + pointId);
        } else {
            return $http.get(API_URL + 'clues/points/' + gameId);
        }
    };
}]);

export default gamesServices;
